import { Button, MenuItem, Select } from "@mui/material"
import { BoxProps } from "@mui/system"
import React, { useEffect } from "react"
import { useTranslation } from "react-i18next"
import { useMediaQuery } from "react-responsive"
import { useRecoilState } from "recoil"
import { SNACKBAR_TYPES } from "src/modules/const"
import { getCareerYearRange } from "src/modules/helper"
import { ShowToast } from "src/states/showToast"
import { Box, TextField, Typography } from "src/UILibrary"

type Props = {
  sx?: BoxProps
  year: number
  month: number
  career: string
  handleYear: any
  handleMonth: any
  handleCareer: any
  handleRemove: any
}

export const CareerInputItem = ({
  sx,
  year,
  month,
  career,
  handleYear,
  handleMonth,
  handleCareer,
  handleRemove,
}: Props) => {
  const { t } = useTranslation("translation", { keyPrefix: "base" })

  const isPC = useMediaQuery({ query: "(min-width: 768px)" })

  const style = sx || {}

  const [, setShowToast] = useRecoilState(ShowToast)

  useEffect(() => {
    if (career.length > 100) {
      setShowToast({
        show: true,
        text: t("please_input_less_than_characters", { length: 100 }),
        type: SNACKBAR_TYPES.WARNING,
      })
      handleCareer(career.slice(0, 100))
    }
  }, [career])

  return (
    <Box sx={{ width: "100%", display: isPC ? "flex" : "block", ...style }}>
      <Box display="flex">
        <Select
          variant="standard"
          sx={{ width: "100px" }}
          value={year}
          onChange={(event) => handleYear(event.target.value)}
        >
          {getCareerYearRange().map((year, index) => {
            return (
              <MenuItem key={index} value={year}>
                {year}
              </MenuItem>
            )
          })}
        </Select>
        <Typography.InputFieldTitle sx={{ mx: "10px", my: "auto" }}>
          {t("year")}
        </Typography.InputFieldTitle>
        <Select
          variant="standard"
          sx={{ width: "100px", textAlign: "center" }}
          value={month}
          onChange={(event) => handleMonth(event.target.value)}
        >
          {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((month, index) => {
            return (
              <MenuItem key={index} value={month}>
                {month}
              </MenuItem>
            )
          })}
        </Select>
        <Typography.InputFieldTitle sx={{ mx: "10px", my: "auto" }}>
          {t("month")}
        </Typography.InputFieldTitle>
      </Box>
      <Box display="flex" width="100%">
        <TextField
          variant="standard"
          placeholder={t("career_placeholder")}
          sx={{
            width: "100%",
            fontFamily: "Noto Sans JP !important",
            ...style,
            mt: "auto",
          }}
          value={career}
          onChange={(event) => handleCareer(event.target.value)}
        />
        <Button
          variant="outlined"
          sx={{
            backgroundColor: "#F1F1F1",
            borderWidth: "1px",
            borderColor: "#F1F1F1",
            width: "25px",
            minWidth: "25px",
            hegith: "25px",
            ml: "10px",
            display: "flex",
          }}
          onClick={() => handleRemove()}
        >
          <Typography.ButtonText sx={{ mx: "auto", my: "auto" }}>-</Typography.ButtonText>
        </Button>
      </Box>
    </Box>
  )
}
